import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TopicVideoDialog from '@/components/topic-video-dialog.vue';
import { getItemGroupTabs } from '@/api/modules/study.js';
import { BAO_TYPE } from '@/views/study/constance.js';
export default {
  name: 'BoxCustomTable',
  components: {
    TopicVideoDialog: TopicVideoDialog
  },
  props: {
    schedule: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    leafNode: {
      type: Boolean
    },
    params: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      baoMap: BAO_TYPE,
      showDialog: false,
      tabs: [],
      title: ''
    };
  },
  computed: {
    studySchedules: function studySchedules() {
      // 处理进度数据，兼容叶子节点的非叶子节点的xxx的ui
      var schedules = [];
      var _this$schedule = this.schedule,
          exercise = _this$schedule.exercise,
          study = _this$schedule.study;

      if (this.leafNode) {
        if (study && study.schedule) {
          study.schedule.forEach(function (item, i) {
            schedules.push(_objectSpread(_objectSpread({}, item), {}, {
              showIcon: i === 0,
              outlineId: study.outLineId,
              type: study.type
            }));
          });
        }

        if (exercise && exercise.schedule) {
          exercise.schedule.forEach(function (item, i) {
            schedules.push(_objectSpread(_objectSpread({}, item), {}, {
              showIcon: i === 0,
              outlineId: exercise.outLineId,
              type: exercise.type
            }));
          });
        }
      } else {
        if (study) {
          study.forEach(function (item, i) {
            schedules.push(_objectSpread(_objectSpread(_objectSpread({}, item), item.schedule[0]), {}, {
              showIcon: i === 0
            }));
          });
        }

        if (exercise) {
          exercise.forEach(function (item, i) {
            schedules.push(_objectSpread(_objectSpread(_objectSpread({}, item), item.schedule[0]), {}, {
              showIcon: i === 0
            }));
          });
        }
      }

      return schedules;
    }
  },
  methods: {
    scheduleTitle: function scheduleTitle(item) {
      var outlineType = item.outlineType,
          nodeName = item.nodeName,
          sectionSeq = item.sectionSeq,
          subSectionSeq = item.subSectionSeq;

      if (outlineType === 3) {
        return "\u5173\u5361".concat(sectionSeq, "-").concat(subSectionSeq);
      }

      return nodeName;
    },
    handleClick: function handleClick(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$getItemGroupTa, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getItemGroupTabs(_objectSpread(_objectSpread({}, _this.params), {}, {
                  outlineId: item.outLineId || item.outlineId,
                  preciousType: item.type,
                  businessId: _this.leafNode ? item.businessId : undefined
                }));

              case 2:
                _yield$getItemGroupTa = _context.sent;
                status = _yield$getItemGroupTa.status;
                data = _yield$getItemGroupTa.data;

                if (!(status !== 1)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _this.tabs = data;
                _this.tabs.obtainMethod = 6;
                _this.title = _this.schedule.name;
                sessionStorage.preciousType = item.type;
                _this.showDialog = true;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};